// 中央競馬ページの既定日付を決める（#231）。
// available_dates には jrdb_bac の開催日も入るため、土曜の時点で翌日の日曜が先頭に来る。
// 先頭をそのまま既定にすると予測の無い未来日が開いてエラーになるので、
// 当日があれば当日、無ければ今日以前で最も新しい日付を選ぶ。

const JST_DATE_FORMAT = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Tokyo',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

// ブラウザのタイムゾーンに関係なく JST の今日を YYYY-MM-DD で返す
export const getTodayJstIsoDate = (now = new Date()) => JST_DATE_FORMAT.format(now);

// dates は YYYY-MM-DD の配列（並び順は問わない）。
// 未来日しか無いときは、画面を空にしないよう最も近い未来日を返す
export const pickDefaultRaceDate = (dates, today) => {
  if (!Array.isArray(dates) || dates.length === 0) return '';
  const sorted = [...dates].sort();
  const past = sorted.filter((date) => date <= today);
  return past.length > 0 ? past[past.length - 1] : sorted[0];
};
